// extracted by mini-css-extract-plugin
module.exports = {"root":"bv_bY"};